import { Component, Input, OnInit } from "@angular/core";
import { User } from "@app/shared/user";
import {
  healthHistoryAdultSurveyId,
  healthHistoryPediatricSurveyId,
} from "@app/survey/survey.service";
import { HomePageAnalyticsService } from "@app/home/home-page-analytics.service";

@Component({
  selector: "om-health-history-card",
  templateUrl: "./health-history-card.component.html",
  styleUrls: ["../default-styling.scss", "./health-history-card.component.scss"],
})
export class HealthHistoryCardComponent implements OnInit {
  @Input() user: User;
  surveyLink: string;

  constructor(private homePageAnalyticsService: HomePageAnalyticsService) {}

  ngOnInit(): void {
    if (this.user.isPediatric()) {
      this.surveyLink = `/survey/${healthHistoryPediatricSurveyId}`;
    } else {
      this.surveyLink = `/survey/${healthHistoryAdultSurveyId}`;
    }

    this.homePageAnalyticsService.trackHealthHistorySurveyLink("om-health-history-card a");
  }
}
